/**
 * HistopathologyConfigHome.js – Masters / Settings home (migrated from admin4.0).
 * Functional component; same flow and design as reference. Uses useNavigate (v6).
 */
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { ClickableCard, CheckAccessFunc } from "../../Components/Common Components/DashboardComponents";
import ImagePaths from "../../Utility/ImagePaths";
import { Colors } from "../../Styles/Colors";
import { localGetItem } from "../../Utility/Services/CacheProviderService";
import "../../Styles/Configuration.css";

const NewHistopathologyConfigList = [
  {
    id: 0,
    main_title: "Histopathology Configuration",
    sub_tab: [
      {
        id: 0,
        sub_title: "Histopathology Masters",
        value: "histoConfig",
        icon: ImagePaths.Histopathology?.default ?? ImagePaths.Histopathology,
        Access: CheckAccessFunc("Histopathology", "Settings", "Histopathology Masters", null, "Tab"),
        path: "/HistopathologySetting/MasterConfiguration",
      },
      {
        id: 1,
        sub_title: "Clinic Configuration",
        value: "clinicConfig",
        icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig,
        Access: CheckAccessFunc("Histopathology", "Settings", "Clinic Configuration", null, "Tab"),
        path: "/HistopathologySetting/ClinicConfiguration",
      },
      {
        id: 2,
        sub_title: "User Configuration",
        value: "userConfig",
        icon: ImagePaths.userConfig?.default ?? ImagePaths.userConfig,
        Access: CheckAccessFunc("Histopathology", "Settings", "User Configuration", null, "Tab"),
        path: "/HistopathologySetting/UserConfiguration",
      },
    ],
  },
];

export default function HistopathologyConfigHome() {
  const navigate = useNavigate();
  const [selectedConfigScreen, setSelectedConfigScreen] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    // User data on mount (for any future role/sms logic)
    JSON.parse(localGetItem("loggedInUserInfo") || "{}");
  }, []);

  const handleConfigNavigation = useCallback(
    (id, item) => {
      setIsSelected(true);
      setSelectedIndex(id ?? null);
      setSelectedConfigScreen(item?.value ?? "");
      if (item?.path) {
        navigate(item.path);
      }
    },
    [navigate]
  );

  return (
    <Box
      component="div"
      className="eMed_Config_Wrapper"
      style={{ backgroundColor: Colors.configHomeBg }}
    >
      {NewHistopathologyConfigList?.map((item, index) => (
        <Box component="div" className="eMed_Config_Div" key={index}>
          <Box
            component="div"
            sx={{
              display: item.sub_tab?.some((sub) =>
                CheckAccessFunc("Histopathology", "Settings", sub.sub_title, null, "Tab")?.viewAccess
              )
                ? "inline"
                : "none",
            }}
          >
            <Typography id="eMed_Config_header">{item?.main_title}</Typography>
          </Box>
          <Box component="div" display="flex" flexWrap="wrap">
            {item?.sub_tab?.map((sub, subIndex) => {
              if (!CheckAccessFunc("Histopathology", "Settings", sub.sub_title, null, "Tab")?.viewAccess) {
                return null;
              }
              return (
                <Box component="div" key={subIndex} id="eMed_Config_mainDiv">
                  <ClickableCard
                    label={sub.sub_title}
                    icon={sub.icon}
                    width="4vw"
                    height="4vw"
                    isSelected={isSelected && selectedIndex === sub.id}
                    onClick={() => handleConfigNavigation(sub.id, sub)}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
